// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { Shield, Lock } from 'lucide-react';
import LandingLogo from './LandingLogo';

export default function LandingFooter({ isFr, setView, scrollToSection, onContact }) {
  const year = new Date().getFullYear();

  return (
    <footer className="dbk-footer">
      <div className="dbk-wrap dbk-footer__grid">
        <div>
          <span className="dbk-footer__logo">
            <LandingLogo />
          </span>
          <p style={{ fontSize: '0.88rem', maxWidth: '32ch' }}>
            {isFr
              ? 'L’outil de gestion des micro-boulangeries artisanales.'
              : 'The management tool for artisan micro-bakeries.'}
          </p>
        </div>

        <div>
          <h4>{isFr ? 'Liens' : 'Links'}</h4>
          <ul>
            <li>
              <button type="button" className="dbk-footer__link" onClick={() => scrollToSection('pricing')}>
                {isFr ? 'Tarif' : 'Pricing'}
              </button>
            </li>
            <li>
              <button type="button" className="dbk-footer__link" onClick={onContact}>
                {isFr ? 'Contact' : 'Contact'}
              </button>
            </li>
            <li>
              <button type="button" className="dbk-footer__link" onClick={() => setView('privacy-policy')}>
                {isFr ? 'Confidentialité' : 'Privacy policy'}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4>{isFr ? 'Sécurité' : 'Trust'}</h4>
          <ul>
            <li className="dbk-footer__trust">
              <Shield size={16} strokeWidth={1.75} />
              {isFr ? 'Hébergé sur Google Cloud' : 'Hosted on Google Cloud'}
            </li>
            <li className="dbk-footer__trust">
              <Lock size={16} strokeWidth={1.75} />
              {isFr ? 'Données chiffrées' : 'Encrypted data'}
            </li>
          </ul>
        </div>
      </div>

      <div className="dbk-footer__base">
        © {year} Digi-Bakery. {isFr ? 'Tous droits réservés.' : 'All rights reserved.'}
      </div>
    </footer>
  );
}
